import * as React from "react";
import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.75 6.74316H20.25H3.75ZM3.75 11.9983H20.25H3.75ZM3.75 17.2534H10.8214H3.75Z", fill: "#D9D9D9" }), /* @__PURE__ */ React.createElement("path", { d: "M3.75 6.74316H20.25M3.75 11.9983H20.25M3.75 17.2534H10.8214", stroke: "#1A2023", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgText);
export { ForwardRef as ReactComponent };
